import React from "react";
import CSSModules from "react-css-modules";
import css from "../../styles.scss";
import { Div } from "components/Base";
import { Submit } from "components/Global/Modal/Layout/Buttons";

const Row = CSSModules(
  ({ name, account, removeAccess }) => (
    <Div display="row.space-between.center">
      <div styleName="rowInfo">
        <span tabIndex="0">{name}</span>
        {account ? (
          <>
            <i className="material-icons" styleName="icon">
              navigate_next
            </i>
            <span tabIndex="0">{account}</span>
          </>
        ) : null}
      </div>
      {removeAccess ? (
        <Div
          fs={1}
          color="danger5"
          role="link"
          underline
          onClick={removeAccess}
        >
          Remove Access
        </Div>
      ) : null}
    </Div>
  ),
  css
);

const ValidRow = CSSModules(
  ({ name, email, account, goToContactProfile, goToAccountProfile }) => (
    <div styleName="row">
      <Row
        goToContactProfile={goToContactProfile}
        goToAccountProfile={goToAccountProfile}
        name={name}
        account={account}
      />
      <div styleName="invalidReason">Email: {email}</div>
    </div>
  ),
  css
);

const InvalidRow = CSSModules(
  ({ name, account, email, removeAccess }) => (
    <div styleName="row">
      <Row removeAccess={removeAccess} name={name} account={account} />
      <div styleName="invalidReason">Email: {email}</div>
    </div>
  ),
  css
);

const ManagePortalAccess = CSSModules(
  ({
    result: { valid, already_has_access, invalid_emails },
    goToContactProfile,
    goToAccountProfile,
    removeAccess,
    givePortalAccess,
    goToShareScreen,
    saving
  }) => {
    return (
      <div styleName="body" style={{ overflowY: "auto", minHeight: "75vh" }}>
        <div styleName="tabBody">
          <div styleName="caption" className={css.caption}>
            <span>
              {valid.length
                ? "People without access:"
                : "⚠️ All selected people have portal access"}
            </span>
            {valid.length ? (
              <Submit
                title={
                  saving ? (
                    <span>
                      <i
                        className={[
                          "fa",
                          "fa-circle-o-notch",
                          css.processingIcon
                        ].join(" ")}
                      />
                      SAVING
                    </span>
                  ) : (
                    <span>Give Portal Access</span>
                  )
                }
                onClick={givePortalAccess}
                props={{ disabled: saving }}
              />
            ) : null}
          </div>
          {valid.map(record => {
            const rowWithHelpers = {
              ...record,
              goToContactProfile: () => goToContactProfile(record.id),
              goToAccountProfile: () => goToAccountProfile(record.account_id)
            };

            return (
              <ValidRow
                key={`${record.id}_${record.account_id}`}
                {...rowWithHelpers}
              />
            );
          })}
        </div>
        <div styleName="tabBody">
          <div styleName="caption" className={css.caption}>
            <span>
              {already_has_access.length
                ? "People with access:"
                : "⚠️ None of the selected people have portal access"}
            </span>
            {already_has_access.length ? (
              <Submit
                title={
                  saving ? (
                    <span>
                      <i
                        className={[
                          "fa",
                          "fa-circle-o-notch",
                          css.processingIcon
                        ].join(" ")}
                      />
                      SAVING
                    </span>
                  ) : (
                    <span>Share Login Details</span>
                  )
                }
                onClick={goToShareScreen}
                props={{ disabled: saving }}
              />
            ) : null}
          </div>
          {already_has_access.map(record => (
            <InvalidRow
              key={`${record.id}_${record.account_id}`}
              email={record.email}
              reason="Already has access"
              removeAccess={() => removeAccess(record.user_id)}
              {...record}
            />
          ))}
        </div>
        {invalid_emails.length ? (
          <div styleName="tabBody">
            <div styleName="caption">
              <span>⚠️ People with invalid email address:</span>
            </div>
            {invalid_emails.map(record => (
              <InvalidRow
                key={`${record.id}_${record.account_id}`}
                email={record.email}
                reason="Invalid Email"
                {...record}
              />
            ))}
          </div>
        ) : null}
      </div>
    );
  },
  css
);

export default ManagePortalAccess;
